import { motion } from 'framer-motion'
import styled from 'styled-components'
import { Close } from '@radix-ui/react-dialog'
import { CloseIcon } from '@velasca/icons/close'

export const Overlay = styled(motion.div)`
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: ${({ theme }) => theme.colors.modalShadow};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 160;
`

export const StyledClose = styled(Close)`
  position: absolute;
  display: inline-flex;
  top: 0;
  right: 0;
  z-index: 10;
  margin: 2rem;
  border: none;
  background: none;
`

export const Content = styled.div`
  overflow: hidden;
  z-index: 170;
  background: ${({ theme }) => theme.colors.background};
  border-radius: 1rem;
  box-shadow:
    hsl(206 22% 7% / 35%) 0px 10px 38px -10px,
    hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1);

  &.shop-the-look-modal {
    @media screen and (max-width: 389px) {
      width: 100%;
    }
    width: 90vw;
    height: 90vh;
    max-width: 1280px;
    padding: 1.5rem 0;

    & > div {
      height: 100%;
    }
  }
`

export const StyledCloseIcon = styled(CloseIcon)`
  path {
    color: ${({ theme }) => theme.colors.border};
  }
`
